export default __webpack_public_path__ + "static/portfolio_gallery_11-1e9cd45a45a677b5b166a49c0602a855.jpg";